// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs-menu {
  font-family: Arial, sans-serif;
  padding: 20px 20px 20px;
  margin-top: 50px;
}
.tabs {
  margin-bottom: 10px;
  border-bottom: 2px solid #007bff;
  width: 1900px;
  position: relative;
  top: 0px;
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tabs-button {
  padding: 12px 24px;
  margin-right: 5px;
  cursor: pointer;
  border: none;
  background-color: #f1f1f1;
  border-radius: 5px 5px 0 0;
  transition: background-color 0.3s, transform 0.2s, box-shadow 0.2s;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  position: relative;
}
.tabs-button:hover {
  background-color: #e0e0e0;
  transform: scale(1.05);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
.tabs-button.active {
  background-color: #007bff;
  color: white;
  font-weight: bold;
  border-bottom: 2px solid transparent;
  box-shadow: none;
}
.tabs-research-name {
  font-size: 20px;
  font-weight: bold;
  color: white;
  margin-left: auto;
  margin-right:20px;
}
.tab-content {
  border: 1px solid #ccc;
  padding: 20px;
  background-color: #fff;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-top: -1px;
  position: relative;
  top: -10px;
  width: 1900px;
}`, "",{"version":3,"sources":["webpack://./src/components/survey/TabsMenu.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,yCAAyC;AAC3C;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf","sourcesContent":[".tabs-menu {\n  font-family: Arial, sans-serif;\n  padding: 20px 20px 20px;\n  margin-top: 50px;\n}\n.tabs {\n  margin-bottom: 10px;\n  border-bottom: 2px solid #007bff;\n  width: 1900px;\n  position: relative;\n  top: 0px;\n  padding-top: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.tabs-button {\n  padding: 12px 24px;\n  margin-right: 5px;\n  cursor: pointer;\n  border: none;\n  background-color: #f1f1f1;\n  border-radius: 5px 5px 0 0;\n  transition: background-color 0.3s, transform 0.2s, box-shadow 0.2s;\n  font-size: 16px;\n  font-weight: 500;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n.tabs-button:hover {\n  background-color: #e0e0e0;\n  transform: scale(1.05);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n.tabs-button.active {\n  background-color: #007bff;\n  color: white;\n  font-weight: bold;\n  border-bottom: 2px solid transparent;\n  box-shadow: none;\n}\n.tabs-research-name {\n  font-size: 20px;\n  font-weight: bold;\n  color: white;\n  margin-left: auto;\n  margin-right:20px;\n}\n.tab-content {\n  border: 1px solid #ccc;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 0 0 5px 5px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  margin-top: -1px;\n  position: relative;\n  top: -10px;\n  width: 1900px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
